import { render, staticRenderFns } from "./SingleHistogram.vue?vue&type=template&id=5bde3a5b&scoped=true&lang=pug"
import script from "./SingleHistogram.vue?vue&type=script&lang=js"
export * from "./SingleHistogram.vue?vue&type=script&lang=js"
import style0 from "./SingleHistogram.vue?vue&type=style&index=0&id=5bde3a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde3a5b",
  null
  
)

export default component.exports